module.exports = __webpack_public_path__ + "static/media/Muli-Regular.8ac1989a.svg";